import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type HeaderCountBadgeTone = 'warning' | 'danger';

@Component({
  selector: 'app-header-count-badge',
  template: '',
  host: {
    '[class]': 'classes',
    'aria-hidden': 'true',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderCountBadgeComponent {
  readonly tone = input<HeaderCountBadgeTone>('warning');

  get classes(): string {
    const layout = 'inline-flex h-nav-alert-dot w-nav-alert-dot items-center justify-center rounded-full';
    const color =
      this.tone() === 'danger'
        ? 'bg-status-danger shadow-badge-danger'
        : 'bg-status-warn shadow-badge-warn';

    return `${layout} ${color}`;
  }
}
